import './EventsList.scss';
import React from 'react';
import { Row } from 'antd';
import Spinner from 'Components/Shared/Spinner/Spinner';
import Button from 'Components/Shared/Button/Button';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import FetchFailureMessage from 'Components/Shared/FetchFailureMessage/FetchFailureMessage';

interface IProps {
  isFetching: boolean;
  isFiltered: boolean;
  isFetchFailed: boolean;
  isShowingAll: boolean;
  isBoxView: boolean;
  visibleEvents: Julius.Website.EventOverviewViewModel[];
  onSetMoreVisibleEvents: () => void;
}

const EventsList: React.SFC<IProps> = ({
  isFetching,
  isFiltered,
  isFetchFailed,
  isShowingAll,
  onSetMoreVisibleEvents,
  children,
}) => {

  if (isFetching) {
    return (
      <WrapperLayout>
        <Spinner height='lg' />
      </WrapperLayout>
    );
  }

  if (isFetchFailed) {
    return (
      <WrapperLayout style='events-list' padding='md'>
        <FetchFailureMessage />
      </WrapperLayout>
    );
  }

  if (!React.Children.count(children) && !isFiltered) {
    return (
      <WrapperLayout style='events-list' padding='md'>
        <FormattedText 
          style='error'
          displayName='Hittade inga evenemang.'
          formattedName='events.message.empty'
        />
      </WrapperLayout>
    );
  }

  if (!React.Children.count(children) && isFiltered){
    return (
      <WrapperLayout style='events-list' padding='md'>
        <FormattedText 
          style='error'
          displayName='Hittade inga evenemang som matchar din sökning.'
          formattedName='events.message.emptywithfilter'
        />
      </WrapperLayout>
    );
  }

  return (
    <WrapperLayout style='events-list'>
      { children }
      { !isShowingAll && 
        <Row type='flex' justify='center' className='events-btn-container'>
          <Button 
            size='large' 
            color='black' 
            extraRadius={ true } 
            boxShadow={ true }
            onClick={ onSetMoreVisibleEvents } 
            >
            <FormattedText
              displayName='Visa fler'
              formattedName='events.showmore'
            />
          </Button> 
        </Row>
      }
    </WrapperLayout>
  );
};

export default EventsList;


// WEBPACK FOOTER //
// ./src/pages/EventsPage/EventsList/EventsList.tsx